/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum KYCMasterFilter {
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
}
